import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class UUIDService {
  /**
   *
   * @returns a UUID v4 string e.g. 'd290f1ee-6c54-4b01-90e6-d701748f0851'
   */
  public generate(): string {
    return uuidv4();
  }
}
